export const timeSlots = [
  { time: '8am' },
  { time: '9am' },
  { time: '10am' },
  { time: '11am' },
  { time: '12pm' },
  { time: '1pm' },
  { time: '2pm' },
  { time: '3pm' },
  { time: '4pm' },
  { time: '5pm' },
  { time: '6pm' },
  { time: '7pm' }
];

export const EXPECTED_DURATION_IN_MINUTES = 480;

export enum NumberOfCalls {
  FiftyPlus = '50+ calls',
  ThirtyPlus = '30+ calls',
  OneToThirty = '1-30 calls'
}

export enum CallType {
  Slash = 'Slash',
  Ameyo = 'Ameyo',
  SelfCall = 'Self call'
}

export enum ActivityAndBreakTypes {
  ACTIVE_IN_LONGHORN = 'active',
  IN_TRAINING = 'training',
  IN_MEETING = 'meeting',
  MORNING_BREAK = 'morning',
  LUNCH_BREAK = 'lunch',
  EVENING_BREAK = 'evening',
  OTHERS = 'others'
}

export const ActivityTypeLabels = {
  [ActivityAndBreakTypes.ACTIVE_IN_LONGHORN]: {
    labelInDef: 'Active in Longhorn',
    contentInTip: 'Active in Longhorn'
  },
  [ActivityAndBreakTypes.IN_TRAINING]: {
    labelInDef: 'Training',
    contentInTip: 'In training'
  },
  [ActivityAndBreakTypes.IN_MEETING]: {
    labelInDef: 'Meeting',
    contentInTip: 'In meeting'
  },
  [ActivityAndBreakTypes.MORNING_BREAK]: {
    labelInDef: 'Morning',
    contentInTip: 'Morning break'
  },
  [ActivityAndBreakTypes.LUNCH_BREAK]: {
    labelInDef: 'Lunch',
    contentInTip: 'Lunch break'
  },
  [ActivityAndBreakTypes.EVENING_BREAK]: {
    labelInDef: 'Evening',
    contentInTip: 'Evening break'
  },
  [ActivityAndBreakTypes.OTHERS]: {
    labelInDef: 'Others',
    contentInTip: 'Other breaks'
  }
};

export enum LoginStatus {
  ON_TIME_LOGGED_IN = 'ON_TIME_LOGGED_IN',
  LATE_LOGGED_IN = 'LATE_LOGGED_IN'
}

export enum CallTypeResponse {
  SLASH = 'SLASH',
  AMEYO = 'AMEYO',
  SELF = 'SELF'
}
